<template>
  <div>
    <div class="alarm-table  personality-form">
      <!-- :columnResizing="true" 标题头可以拉伸-->
      <!--<DataGrid
        v-loading="loading"
        :data="alarm_data"
        :border="false"
        :striped="true"
        :row-css="getRowCss"
        :style="{height:bottom_height+'px'}"
        class="f-full"
        @rowContextMenu="alarm_right_click"
        @rowDblClick="dblClick_Acknowledge"
        @sortChange="sortChange"
        :columnResizing="true"
        :checkbox="true"
      >
        &lt;!&ndash;<GridColumn
          align="left"
          title=""
          width="50"
        >
          <template
            slot="body"
            slot-scope="scope"
          >
            <CheckBox ></CheckBox>
          </template>
</GridColumn>&ndash;&gt;
<GridColumn :sorter="sorter" field="state" align="left" title="报警状态" width="100">
  <template slot="body" slot-scope="scope">
            <span :title="scope.row.state">{{ scope.row.state }}</span>
          </template>
</GridColumn>
<GridColumn :sortable="false" :sorter="sorter" field="count" align="left" title="累计次数" width="100">
  <template slot="body" slot-scope="scope">
            <span :title="scope.row.count">{{ scope.row.count }}</span>
          </template>
</GridColumn>
<GridColumn :sortable="true" :sorter="sorter" field="lastChange" title="最后变化时间" @click="test1()" align="left"
  width="150">
  <template slot="body" slot-scope="scope">
            <div class="item">
              <div :title="timeExchange(scope.row.lastChange)">{{ timeExchange(scope.row.lastChange) }}</div>
            </div>
          </template>

</GridColumn>
<GridColumn :sorter="sorter" field="objectName" title="报警对象" align="left" width="750">
  <template slot="body" slot-scope="scope">
            <span :title="scope.row.objectName">{{ scope.row.objectName }}</span>
          </template>
</GridColumn>
<GridColumn :sorter="sorter" field="description" align="left" title="报警描述" width="100">
  <template slot="body" slot-scope="scope"><span :title="scope.row.description">{{ scope.row.description }}</span>
          </template>
</GridColumn>
&lt;!&ndash; <GridColumn :sorter="sorter" field="linkedobject" align="left" title="关联对象" width="100">
  <template slot="body" slot-scope="scope">
            <span :title="scope.row.linkedobject">{{ scope.row.linkedobject }}</span>
          </template>
</GridColumn>&ndash;&gt;
<GridColumn :sortable="false" :sorter="sorter" field="tripped" title="触发时间" align="left" width="100">
  <template slot="body" slot-scope="scope">
            <div class="item">
              <div :title="timeExchange(scope.row.tripped)">{{ timeExchange(scope.row.tripped) }}</div>
            </div>
          </template>
</GridColumn>
<GridColumn :sorter="sorter" field="user" title="操作用户" align="left" width="100">
  <template slot="body" slot-scope="scope">
            <span :title="scope.row.user">{{ scope.row.user }}</span>
          </template>
</GridColumn>
</DataGrid>-->
      <el-table :data="alarm_data" height='330px' size="mini"
        :header-cell-style="{ background: '#343434', color: '#c7c7c9', border: '1px solid #343434' }"
        @row-contextmenu="rightClick" :cell-style="statusStyle" class="personality-form" style="width: 100%">
        <el-table-column prop="state" align="center" label="报警状态" width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.state === 'Alarm'">报警</span>
            <span v-if="scope.row.state === 'Acknowledged'">确认报警</span>
            <span v-if="scope.row.state === 'Normal'">恢复</span>
          </template>
        </el-table-column>
        <el-table-column prop="count" align="center" label="累计次数" width="170">
        </el-table-column>
        <el-table-column prop="lastChange" align="center" width="200" :formatter="timestampToTime" label="最后变化时间">
        </el-table-column>
        <el-table-column prop="objectName" align="center" label="报警对象">
        </el-table-column>
        <el-table-column prop="description" align="center" width="180" label="报警描述">
        </el-table-column>
        <el-table-column prop="tripped" align="center" width="180" :formatter="timestampToTimeEnd" label="触发时间">
        </el-table-column>
        <el-table-column prop="user" align="center" label="操作用户" width="180">
        </el-table-column>
      </el-table>
    </div>
    <!--报警列表的右键菜单-->
    <Menu ref="alarm_context_menu" :duration="1000" @itemClick="tree_menuItemClick">
      <MenuItem text="确认" iconCls="icon-confirm">
      </MenuItem>
      <Menu-sep />
      <MenuItem text="禁用" iconCls="icon-disabled">
      </MenuItem>
      <MenuItem text="启用" iconCls="icon-enable">
      </MenuItem>
      <Menu-sep />
      <MenuItem text="清除" iconCls="icon-clear">
      </MenuItem>
      <Menu-sep />
      <MenuItem text="显示禁用的报警" iconCls="icon-showAlarm">
      </MenuItem>
      <MenuItem text="事件视窗" iconCls="icon-event-window">
      </MenuItem>
      <Menu-sep />
      <MenuItem text="刷新" iconCls="icon-reflash">
      <div align="right" style="font-size: 12px">F5</div>
      </MenuItem>
      <Menu-sep />
      <MenuItem iconCls="icon-alarmProperties" text="报警属性">
      </MenuItem>
    </Menu>
    <div class="pagination-box">
      <!--<gs-pagination
        ref="pagination"
        :current="1"
        :before-jump="page => beforeJump(page)"
        :total="total"
        :page-size="params.pageSize"
        class="gs-pagination"
        @page-change="pageChange"
      />-->
      <el-pagination :page-size="params.pageSize" :current-page="params.pageNum" :pager-count="count"
        @current-change="pageChange" layout="prev, pager, next" :page-count="pages">
      </el-pagination>
    </div>
    <gs-modal v-model="visible" :before-close="beforeClose" class="my-test-class" title="删除" @close="close"
      @confirm="handleConfirm">
      <span>你确认要删除该报警吗？</span>
    </gs-modal>
    <gs-modal v-model="forbiddenList" :before-close="forbiddenClose" width="50%" class="my-test-class" title="禁用报警列表"
      @close="forbiddenClose" @confirm="handleForbiddenConfirm">
      <!--<el-row style="margin-top: 1%;margin-left: 1%">
        <el-col :span="4" style="">
          <el-input
            placeholder="请输入模板名称"
            v-model="link"
            size="small"
            clearable>
          </el-input>
        </el-col>
        <el-col :span="4" style="margin-left: 1%"><el-button @click="links" type="info" icon="el-icon-search" size="small" circle></el-button></i>
        </el-col>
      </el-row>-->
      <el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" border
        style="width: 98%;margin-top: 1%;margin-left: 1%"
        :header-cell-style="{ background: '#343434', color: '#c7c7c9', border: '1px solid #343434' }" size="mini">
        <el-table-column label="报警状态" prop="state" align="center" width="120">
        </el-table-column>
        <el-table-column label="累计次数" prop="count" align="center">
        </el-table-column>
        <el-table-column label="报警对象" prop="" align="center">
        </el-table-column>
        <el-table-column label="报警描述" prop="description" align="center">
        </el-table-column>
        <el-table-column label="关联对象" prop="" align="center">
        </el-table-column>
        <el-table-column label="触发时间" prop="tripped" align="center">
        </el-table-column>
        <el-table-column label="操作用户" prop="user" align="center">
        </el-table-column>
        <el-table-column label="操作" align="center" min-width="80">
          　<template slot-scope="scope">
            <el-button type="success" size="mini" @click="starts(scope.row)">启用</el-button>
            　
          </template>
        </el-table-column>
      </el-table>
    </gs-modal>
    <gs-modal v-model="clearpolice" :before-close="closePolice" class="my-test-class" title="报警数据保存时间"
      @close="closePolice" @confirm="confirmPoliceCycle">
      <!-- <gs-form ref="form" :model="form" label-width="70px">
        <gs-form-item label="周期">
          <gs-select v-model="form.clepopcyc" placeholder="请选保存周期">
            <gs-option label="每周" value="week"></gs-option>
            <gs-option label="每月" value="month"></gs-option>
            <gs-option label="每季" value="season"></gs-option>
          </gs-select>
        </gs-form-item>
      </gs-form>-->
    </gs-modal>
    <!--筛选条件-->
    <gs-modal v-model="screenModel" :before-close="beforeCloseScreen" class="time-event-dialog-modal" title="筛选"
      width="35%" @confirm="handleConfirmScreen">
      <!--  <gs-tabs v-model="activeName" type="content-tab" @tab-click="handleClick">
        <gs-tab-pane label="常规" name="first">
          <gs-form
            :model="form"
            label-width="95px"
            label-position="left"
            gap="small"
          >
            <gs-form-item
              label="描述"
              prop="target"
              class="form-item-radio"
            >
              <gs-input
                ref="nameInput"
              />
            </gs-form-item>
            <gs-form-item
              label="id"
              prop="target"
              class="form-item-radio"
            >
              <gs-input
                ref="nameInput"
              />
            </gs-form-item>
            <gs-form-item
              label="报警对象"
              prop="target"
              class="form-item-radio"
            >
              <gs-input
                ref="nameInput"
              />
            </gs-form-item>
            <gs-form-item
              label="用户"
              prop="target"
              class="form-item-radio"
            >
              <gs-input
                ref="nameInput"
              />
            </gs-form-item>
          </gs-form>
        </gs-tab-pane>
        <gs-tab-pane label="报警优先级" name="second">
          <gs-form
            :model="form"
            label-width="95px"
            label-position="left"
            gap="small"
          >
            <gs-form-item
              label="优先事项"
              prop="target"
              class="form-item-radio"
            >
              <gs-input
                ref="nameInput"
              />
            </gs-form-item>
            <fieldset>
              <legend>报警次数</legend>
              <gs-form-item
                label="最小次数"
                prop="target"
                class="form-item-radio"
                style="margin-left: 15px"
              >
                <gs-input-number  :min="0" :max="1000" label="描述文字"></gs-input-number>
              </gs-form-item>
              <gs-form-item
                label="最大次数"
                prop="target"
                class="form-item-radio"
                style="margin-left: 15px"
              >
                <gs-input-number   :min="0" :max="1000" label="描述文字"></gs-input-number>
              </gs-form-item>
            </fieldset>
          </gs-form>
        </gs-tab-pane>
        <gs-tab-pane label="扩展" name="third">
          <gs-form
            :model="form"
            label-width="95px"
            label-position="left"
            gap="small"
          >
            <gs-form-item
              label="秘钥标签"
              prop="target"
              class="form-item-radio"
            >
              <gs-input
                ref="nameInput"
              />
            </gs-form-item>
            <gs-form-item
              label="设备名称"
              prop="target"
              class="form-item-radio"
            >
              <gs-input
                ref="nameInput"
              />
            </gs-form-item>
            <gs-form-item
              label="连接名称"
              prop="target"
              class="form-item-radio"
            >
              <gs-input
                ref="nameInput"
              />
            </gs-form-item>
            <gs-form-item
              label="特定字段"
              prop="target"
              class="form-item-radio"
            >
              <gs-input
                ref="nameInput"
              />
            </gs-form-item>
            <gs-form-item
              label="站点名称"
              prop="target"
              class="form-item-radio"
            >
              <gs-input
                ref="nameInput"
              />
            </gs-form-item>
          </gs-form>
        </gs-tab-pane>
        <gs-tab-pane label="日期和时间" name="fourth">
          <gs-form
            :model="form"
            label-width="95px"
            label-position="left"
            gap="small"
          >
            <fieldset>
              <legend>报警时间区间</legend>
              <gs-form-item
                label="开始时间"
                prop="target"
                class="form-item-radio"
                style="margin-left: 15px"
              >
                <gs-date-picker
                  type="date-time"
                  input-type="input"
                  placeholder="选择日期">
                </gs-date-picker>
              </gs-form-item>
              <gs-form-item
                label="结束时间"
                prop="target"
                class="form-item-radio"
                style="margin-left: 15px"
              >
                <gs-date-picker
                  type="date-time"
                  input-type="input"
                  placeholder="选择日期">
                </gs-date-picker>
              </gs-form-item>
            </fieldset>
          </gs-form>
        </gs-tab-pane>
      </gs-tabs>-->
    </gs-modal>
  </div>
</template>
<script>
import service from '../../service/alarmService.js'
import timeExchange from '../../utils/timestampToFormat.js'
import { mapState } from 'vuex'
export default {
  data() {
    return {
      activeName: 'first',
      screenModel: false,
      searchData: '',
      form: {
        clepopcyc: '',// 清除报警周期
      },
      clearpolice: false,
      forbiddenList: false,
      tableData: [],
      link: '',
      visible: false,
      selectNode: null,
      selectedNodeType: '',
      params: {
        pageSize: 50,
        pageNum: 1,
        sortField: 'state',
        sortOrder: 'asc'
      },
      total: 0,
      pages: 0,
      count: 11,
      alarm_data: [],
      loading: false,
      timestamp: 0,
      timeExchange: timeExchange,
      timer: null,
      bottom_height: `${(document.documentElement.clientHeight - 100) * 0.5 - 110}`
    }
  },
  computed: {
    ...mapState({
      loginStatus: 'loginStatus'
    })
  },
  watch: {
    loginStatus() {
      if (!this.loginStatus) {
        clearInterval(this.timer)
      }
    },
    '$store.state.policeArray'(newval, olval) {
      //console.log(newval)
      /*for(let i =0;i<newval.length;i++){
        if(newval[i].state === "Acknowledged"){
          newval[i].state = "确认报警"
        }
        if(newval[i].state === "Alarm"){
          newval[i].state = "报警"
        }
        if(newval[i].state === "Normal"){
          newval[i].state = "恢复"
        }
      }*/
      this.alarm_data = newval
    }
  },
  mounted() {
    this.loading = true
    clearInterval(this.timer)
    service.getCustomAlarmList(this.params).then(res => {
      this.pages = res.pages
      this.total = res.total
      this.alarm_data = res.data
      this.$store.state.alarmNum = res.total
      this.loading = false
    }).catch(err => {
      this.$Message.error(err.message)
      clearInterval(this.timer)
    })
    /* this.timer = setInterval(() => {
       service.getAlarmList(this.params).then(res => {
         this.total = res.total
         this.alarm_data = res.data
         this.$store.state.alarmNum = res.total
         this.loading = false
       }).catch(err => {
         this.$Message.error(err.message)
         clearInterval(this.timer)
       })
     }, 1000)*/
  },
  destroyed() {
    clearInterval(this.timer)
  },
  methods: {
    timestampToTime(row, column) {
      var date = new Date(row.lastChange) // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var Y = date.getFullYear() + '-'
      var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
      var D = date.getDate() + ' '
      var h = date.getHours() + ':'
      var m = date.getMinutes() + ':'
      var s = date.getSeconds()
      return Y + M + D + h + m + s
    },
    timestampToTimeEnd(row, column) {
      var date = new Date(row.tripped) // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var Y = date.getFullYear() + '-'
      var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
      var D = date.getDate() + ' '
      var h = date.getHours() + ':'
      var m = date.getMinutes() + ':'
      var s = date.getSeconds()
      return Y + M + D + h + m + s
    },

    // 改变某一行颜色
    statusStyle({ row, column, rowIndex, columnIndex }) {
      if (row.state === 'Alarm') {
        return 'color:#e51f02'
      }
      if (row.state === 'Acknowledged') {
        return 'color:#30cb22'
      }
    },
    // 改变回显的值

    // elementui鼠标右键
    rightClick(event, row, column) {
      this.selectNode = event
      this.selectedNodeType = event.type
      this.$refs.alarm_context_menu.showContextMenu(column.x, column.y)
    },
    beforeCloseScreen() {
      this.screenModel = false
    },
    handleConfirmScreen() {
      this.screenModel = false
    },
    // 定时清除报警
    clearPolices() {
      this.clearpolice = true
    },
    // 关闭定时清除报警窗口
    closePolice() {
      this.clearpolice = false
    },
    // 点击确认清除报警周期
    confirmPoliceCycle() {
      this.clearpolice = false
    },
    handleClick(tab, event) {
      let _this = this
      if (tab.label === "禁用报警") {
        clearInterval(this.timer)
        service.forbiddenShow(this.params).then(res => {
          _this.alarm_data = res.data
        })
      } else if (tab.label === "Alarm") {
        this.loading = true
        clearInterval(this.timer)
        service.getCustomAlarmList(this.params).then(res => {
          this.total = res.total
          /*for(let i =0;i<res.data.length;i++){
            if(res.data[i].state === "Acknowledged"){
              res.data[i].state = "确认报警"
            }
            if(res.data[i].state === "Alarm"){
              res.data[i].state = "报警"
            }
            if(res.data[i].state === "Normal"){
              res.data[i].state = "恢复"
            }
          }*/
          this.alarm_data = res.data
          this.$store.state.alarmNum = res.total
          this.loading = false
        }).catch(err => {
          this.$Message.error(err.message)
          clearInterval(this.timer)
        })
        this.timer = setInterval(() => {
          service.getCustomAlarmList(this.params).then(res => {
            this.total = res.total
            /*for(let i =0;i<res.data.length;i++){
              if(res.data[i].state === "Acknowledged"){
                res.data[i].state = "确认报警"
              }
              if(res.data[i].state === "Alarm"){
                res.data[i].state = "报警"
              }
              if(res.data[i].state === "Normal"){
                res.data[i].state = "恢复"
              }
            }*/
            this.alarm_data = res.data
            this.$store.state.alarmNum = res.total
            this.loading = false
          }).catch(err => {
            this.$Message.error(err.message)
            clearInterval(this.timer)
          })
        }, 1000)
      }
    },
    //警用列表窗口方法
    test1() {
      console.info("警用列表窗口方法！Test")
    },
    links() {
      alert("模糊查询")
    },
    forbiddenClose() {
      this.forbiddenList = false
    },
    handleForbiddenConfirm() {
      this.forbiddenList = false
    },
    // 报警方法
    sorter(field1, field2) {
      return null
    },
    beforeJump(page, pagination = 'pagination') {
      if (isNaN(page) || page < 1 || page > this.$refs[pagination].totalPage) {
        this.$Message.error('请输入正确页数')
        return false
      }
    },
    pageChange(pageNum) {
      this.params.pageNum = pageNum
      this.loading = true
      service.getCustomAlarmList(this.params).then(res => {
        this.total = res.total
        this.alarm_data = res.data
        this.tableData = res.data
        this.loading = false
      })
    },
    dblClick_Acknowledge(row) {
      if (row.state === 'Acknowledged') {
        this.$notify({
          message: '报警已确认,无需重复确认!',
          type: 'warning',
          offset: 25
        });
        return
      }
      this.acknowledgeAlarm(row)
    },
    //刷新
    renovate() {
      this.$notify.success({
        message: '刷新报警成功',
        offset: 25
      });
    },
    //禁用
    forbidden() {
      let data = this.selectNode
      service.forbidden(data).then(res => {
        this.$notify.success({
          message: '禁用报警成功',
          offset: 25
        });
      })
    },
    //启用
    startUsing() {
      let data = this.selectNode
      service.startUsing(data).then(res => {
        this.$notify.success({
          message: '报警启用成功',
          offset: 25
        });
      })
    },
    starts(row) {
      service.startUsing(row).then(res => {
        this.$Message.success('报警启用成功')
      })
    },
    //显示禁用
    forbiddenShow() {
      let _this = this
      service.forbiddenShow(this.params).then(res => {
        _this.tableData = res.data
        _this.forbiddenList = true
      })
    },
    acknowledgeAlarm(params) {
      let _this = this
      service.acknowledgeAlarm(params).then(res => {
        this.$notify.success({
          message: '确认报警成功',
          offset: 25
        });
        service.getCustomAlarmList(this.params).then(res => {
          this.pages = res.pages
          this.total = res.total
          this.alarm_data = res.data
          this.$store.state.alarmNum = res.total
          this.loading = false
        }).catch(err => {
          this.$Message.error(err.message)
          clearInterval(this.timer)
        })
      }).catch(err => {
        this.$notify.error({
          message: '确认报警失败，此设备或已删除',
          offset: 25
        });
      })

    },
    purgeAlarm(params) {
      /*if(params.state === "确认报警"){
        params.state = 'Acknowledged'
      }
      if(params.state === "报警"){
        params.state = "Alarm"
      }
      if(params.state === "恢复"){
        params.state = "Normal"
      }*/
      service.purgeAlarm(params).then(res => {
        this.$notify.success({
          message: '成功清除报警',
          offset: 25
        });
      })
    },
    close() {
      this.visible = false
    },
    beforeClose() {
      this.visible = false
    },
    handleConfirm() {
      this.purgeAlarm(this.selectNode)
      this.visible = false
    },
    alarm_right_click(event) {
      this.selectNode = event.row
      this.selectedNodeType = event.row.type
      this.$refs.alarm_context_menu.showContextMenu(event.originalEvent.x, event.originalEvent.y)
    },
    getRowCss(row) {
      if (row.state === 'Alarm') {
        return { background: '#ff4144' }
      }
      if (row.state === 'Acknowledged') {
        return { background: '#0fe616' }
      }
      return null
    },
    tree_menuItemClick(event) {
      switch (event) {
        case '确认':
          this.dblClick_Acknowledge(this.selectNode)
          break
        case '清除':
          this.visible = true
          break
        case '刷新':
          this.renovate()
          break
        case '禁用':
          this.forbidden()
          break
        case '启用':
          this.startUsing()
          break
        case '显示禁用的报警':
          this.forbiddenShow()
          break
        default:
          break
      }
    },
    sortChange(sorts) {
      this.params.sortField = sorts[0].field
      this.params.sortOrder = sorts[0].order
      this.pageChange(this.params.pageNum)
    }
  }
}
</script>
<style lang='scss'>
.el-tabs--border-card>.el-tabs__content {
  padding: 0px;
}

.datagrid-sort-desc .datagrid-sort-icon {
  display: none;
}

.icon-confirmi {
  width: 17px;
  height: 17px;
  background: url("/static/img/new-icno/确认.png") no-repeat center center;
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

.icon-start {
  cursor: pointer;
  width: 17px;
  height: 17px;
  background-image: url("/static/img/new-icno/清除.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  margin-top: 2%;
  margin-left: 10px;
}

.icon-show {
  width: 17px;
  height: 17px;
  background-image: url("/static/img/new-icno/显示报警.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  margin-top: 2%;
  margin-left: 10px;
}

.icon-flash {
  width: 17px;
  height: 17px;
  background-image: url("/static/img/new-icno/刷新.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  margin-top: 2%;
  margin-left: 10px;
}

.icon-properties {
  width: 17px;
  height: 17px;
  background-image: url("/static/img/new-icno/报警属性.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  margin-left: 10px;
}

.icon-clears {
  width: 17px;
  height: 17px;
  background-image: url("/static/img/new-icno/清除.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  margin-left: 10px;
}

.pagination-box {
  min-width: 620px;
  float: right;
}

//  #rMenu {
//   position:absolute;
//   visibility:hidden;
//   top:0;
//   background-color: #fff;
//   text-align: left;
//   padding: 2px;
//   border: 1px solid #DFDFDF;
//   font-size: 14px;
// }
// .right-menu-li{

// 	margin: 1px 0;
// 	padding: 5px 15px 5px 10px;
// 	cursor: pointer;
// 	list-style: none outside none;
// 	background-color: #fff;
//   border-bottom: 1px solid #DFDFDF;
// }</style>
<style scoped></style>



// WEBPACK FOOTER //
// src/components/alarm/alarmList1.vue